const cache = {
  state: {
    cacheParams: {}
  },
  mutations: {
    SET_CACHEPARAMS(state, data) {
      state.cacheParams = data
    },
    SET_TABINDEX_PREMISSION(state, data){
      state.tabIndexPermission = data;
    }
  },
  actions: {
    action_set_cacheParams({ commit }, data) {
      commit('SET_CACHEPARAMS', data)
    }
  }
}

export default cache



// WEBPACK FOOTER //
// ./src/store/modules/cache.js